import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });
api.interceptors.request.use((config) => {
  const tenantId = localStorage.getItem("cm_active_tenant");
  if (tenantId) config.headers["X-Tenant-ID"] = tenantId;
  return config;
});
api.interceptors.response.use((response) => response, (error) => {
  if (error.response?.status === 403 && error.response?.data?.detail === "ATTENDANCE_REQUIRED" && window.location.pathname !== "/check-in") {
    window.location.assign("/check-in");
  }
  return Promise.reject(error);
});

export default api;

export const inr = (v) => "₹" + Math.round(v || 0).toLocaleString("en-IN");
export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—";
export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";

export const COMPANY_STYLES = {
  Cleanmates: "bg-info-tint text-info border-info/30",
  PestGenis: "bg-warning-tint text-warning border-warning/30",
  "StainGuard Pro": "bg-primary-tint text-primary border-primary/30",
  Rover: "bg-danger-tint text-danger border-danger/30",
  Limpio: "bg-primary-tint text-primary border-primary/30",
};

export async function downloadFile(path, filename) {
  const tenantId = localStorage.getItem("cm_active_tenant");
  const headers = tenantId ? { "X-Tenant-ID": tenantId } : {};
  const res = await fetch(`${API}${path}`, { credentials: "include", headers });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function getPosition() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 8000 }
    );
  });
}
